<p-toast  key="globalToast"/>
<router-outlet></router-outlet>
<app-loading></app-loading>